module.exports = __webpack_public_path__ + "static/other/gameUniformDesignOther.b97231a7.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignOther.json
// module id = 2542
// module chunks = 0